import React from 'react';
import './workStatMnth.css';
import { useTranslation } from 'react-i18next';


export const WorkStatMnth = ({ employeeWorkDetails }) => {

    const {t} = useTranslation();

    // Get current month and year
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth(); // 0-indexed (January is 0)
    const currentYear = currentDate.getFullYear();

    // Filter work details for the current month
    const currentMonthWorkDetails = employeeWorkDetails.filter(detail => {
        const workDate = new Date(detail.work_date);
        return workDate.getMonth() === currentMonth && workDate.getFullYear() === currentYear;
    });

    // Calculate total worked hours and minutes for the current month
    let totalMinutes = currentMonthWorkDetails.reduce((total, detail) => {
        if (detail.work_duration && typeof detail.work_duration === 'string') {
            const durationParts = detail.work_duration.split(':');
            if (durationParts.length === 3) {
                const hours = parseInt(durationParts[0], 10) || 0;
                const minutes = parseInt(durationParts[1], 10) || 0;
                total += hours * 60 + minutes;
            }
        }
        return total;
    }, 0);

    const totalHours = Math.floor(totalMinutes / 60);
    const totalRemainingMinutes = totalMinutes % 60;

    return (
        <div className='WorkStat-body'>
            <div className='WorkStat-worked-headerbody'>
                <div className='WorkStat-worked-header'>
                   <span>{t("employeeWorkDetails_month")}</span>
                </div>
            </div>
            <div className='WorkStat-worked-duration'>
                {totalHours} Hrs {totalRemainingMinutes} Mins
            </div>
            <div className='WorkStat-worked-footer'>
                {getMonthName(currentMonth)} {currentYear}
            </div>
        </div>
    );
};

// Helper function to get month name from index
const getMonthName = (monthIndex) => {
    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    return months[monthIndex];
};

export default WorkStatMnth;
